import GeneralSettingsList from "./GeneralSettingsList";

export default {
    list: GeneralSettingsList,
}
